import styled from "styled-components"
import { TripleGrid } from "../../Global"

export const TrainersGrid = styled(TripleGrid)`
  gap: 25px;
`
